

import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider, CustomProvider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyBwWjNXk9ZE2d_j57r2a6h3ErAYR-V7lZc",
  authDomain: "drrx117.firebaseapp.com",
  projectId: "drrx117",
  storageBucket: "drrx117.appspot.com",
  messagingSenderId: "676413950447",
  appId: "1:676413950447:web:a2c8362b486229896a8e1a",
  measurementId: "G-8N9QDLTTRN"
};

const app = initializeApp(firebaseConfig);

// --- SECURITY: App Check Initialization ---
// ReCaptcha v3 requires domains to be registered in Google reCAPTCHA Console.
// On non-production preview domains (e.g. *.run.app, localhost), we skip or use debug token.
const APP_CHECK_TOKEN = "6LdJkiYsAAAAAB1DeGCUMsJN_TdSlcRXFADC8GVb"; 

if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  const isProductionDomain = 
    hostname === 'drrx.app' || 
    hostname === 'www.drrx.app' ||
    hostname.endsWith('.web.app') ||
    hostname.endsWith('.firebaseapp.com');

  const debugToken = (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN || (import.meta as any).env?.VITE_APP_CHECK_DEBUG_TOKEN;

  if (isProductionDomain) {
    try {
      initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(APP_CHECK_TOKEN),
        isTokenAutoRefreshEnabled: true
      });
      console.log("🛡️ App Check successfully initialized with ReCaptchaV3.");
    } catch (e) {
      console.warn("App Check failed to initialize:", e);
    }
  } else if (debugToken) {
    try {
      (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
      initializeAppCheck(app, {
        provider: new CustomProvider({
          getToken: async () => ({
            token: typeof debugToken === 'string' ? debugToken : 'debug-token',
            expireTimeMillis: Date.now() + 3600000
          })
        }),
        isTokenAutoRefreshEnabled: true
      });
      console.log("🛡️ App Check initialized with debug provider.");
    } catch (e) {
      console.warn("App Check debug initialization error:", e);
    }
  }
}

if (typeof window !== 'undefined') {
  isSupported().then((supported) => {
    if (supported) {
      getAnalytics(app);
    }
  });
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');